export const BotStatus = {
  Error: 'error',
  Timeout: 'timeout',
  Running: 'running',
  Success: 'success',
  NotLaunched: 'notlaunched',
} as const;

export type BotStatus = (typeof BotStatus)[keyof typeof BotStatus];

export interface HelloProps {
  sid: string
  file_id: string
  file_orga_id: string
  cnSoft: boolean
}

export interface ColItem {
  id?: string
  coltype: 'fileorga' | 'file' | 'custom' | 'coldebase'
  filecolid: string
  name: string
  custom?: CustomItem
  rank?: number
  displayInTable: boolean
  filterInMap: boolean
  list_pdv_btn_filter?: boolean
  visible_table_btn?: boolean
}

export interface CustomItem {
  inputtype: 'text' | 'select'
  name: string
  options?: OptionItem[]
}

export interface OptionItem {
  id: string
  name: string
}
